import CookieButton from './cookie-button/cookie-button.component';
import CookieSetting from './cookie-setting/cookie-setting.component';
import CookieDialog from './cookie-dialog/cookie-dialog.component';
// import CookieFunctionalDialog from './cookie-functional-dialog/cookie-functional-dialog';

customElements.define('cookie-dialog', CookieDialog);
customElements.define('cookie-button', CookieButton);
customElements.define('cookie-setting', CookieSetting);
// customElements.define('cookie-functional-dialog', CookieFunctionalDialog);
